module.exports = __webpack_public_path__ + "img/files-icon.2773f01f.png";